import React, { useEffect, useCallback, useState} from 'react';
import {sleep} from "utils/sleep.js"
import {
    setSelectedZObject} from 'actions/index.js';
import ZObjectComponent from "components/zobject/ZObjectComponent.js";
import {connect} from 'react-redux';
import Colors from 'components/Colors.js';

const colors = new Colors();

const FMShader = ({
    hd1,
    hd2,
    hd3,
    hd4,
    md1,
    md2,
    md3,
    md4,
    algo, color, instrument, h1, h2, h3, h4, m1, m2, m3, m4, setSelectedZObject, selectedOscillator}) => { 
    let [zobject, setZObject] = useState(undefined);
    useEffect(() => {
        if (instrument.fmShader && !zobject) {
            setZObject(instrument.fmShader);
            return;
        }
        instrument.track.subSequence.loadSubPatch("fm-harmonicity-mod-22")
            .then(async o => {
                console.log("LOADED SUB PATCH=", o);
                console.log(o);
                o.hide();
                instrument.fmShader = o;
                o.doNotSave = true;

                let track = instrument.track;

                while (o.effect.inletObjects.length < 4) {
                    await sleep(20);
                }
                let _color = colors.getColorForHash(track.presetName || track.id);
                console.log("COLOR FOR HASH=", _color);
                o.effect.inletObjects[0].execute(_color);
                o.effect.inletObjects[3].execute(getModList(instrument));
                setZObject(o);
            });
    }, [setZObject]);

    useEffect(() => {
        if (zobject) {
            zobject.width = 244;
            zobject.height = 140;
        }
    }, [zobject]);

    useEffect(() => {
        if (!zobject) {
            return;
        }
        zobject.effect.inletObjects[3].execute(getModList(instrument));
    }, [zobject, algo]);

    useEffect(() => {
        if (!zobject) {
            return;
        }
        let mds = [md1,md2,md3,md4];
        let md = [];
        for (let i=0; i<4; i++) {
            let d = mds[i];
            if (instrument.oscillatorNodes[i].modulationIndexParameter.isConnectedToAnyModulator()) {
                md.push(d);
            } else {
                md.push(0);
            }
        }

        let hds = [hd1,hd2,hd3,hd4];
        let hd = [];
        for (let i=0; i<4; i++) {
            let d = hds[i];
            if (instrument.oscillatorNodes[i].harmonicityParameter.isConnectedToAnyModulator()) {
                hd.push(d);
            } else {
                hd.push(0);
            }
        }
        // depths of modulation for harmonicites and mod indices need to be sent to shader
        zobject.effect.inletObjects[5].execute(hd);
        zobject.effect.inletObjects[6].execute(md);
    }, [zobject, md1, md2, md3, md4, hd1, hd2, hd3, hd4]);

    useEffect(() => {
        if (!zobject) {
            return;
        }
        zobject.effect.inletObjects[4].execute(selectedOscillator+1);
    }, [zobject, selectedOscillator]);

    useEffect(() => {
        if (!zobject) {
            return;
        }
        // harmonicites and mod indices need to be sent to shader
        let h = [h1,h2,h3,h4];
        let m = [m1,m2,m3,m4];
        zobject.effect.inletObjects[1].execute(h);
        zobject.effect.inletObjects[2].execute(m);
    }, [m1,m2,m3,m4,h1,h2,h3,h4,zobject]);

    useEffect(() => {
        if (!zobject) {
            return;
        }
        let track = instrument.track;
        let _color = colors.getColorForHash(track.presetName || track.id);
        zobject.effect.inletObjects[0].execute(_color);
    }, [zobject, color]);

    if (!zobject) {
        return '';
    }
    return (<ZObjectComponent zobject={zobject} forceShow={true}/>);
};

const mapStateToProps = (state, props) => {
    let oscillators = props.instrument.oscillatorNodes;
    if (!oscillators) {
        return {};
    }
    let c = oscillators[0];
    let a = oscillators[1];
    let b1 = oscillators[2];
    let b2 = oscillators[3];

    let params = state.effects.effectParameters;
    return {
        h1: params[c.harmonicityParameter.id],
        h2: params[a.harmonicityParameter.id],
        h3: params[b1.harmonicityParameter.id],
        h4: params[b2.harmonicityParameter.id],
        m1: params[c.modulationIndexParameter.id],
        m2: params[a.modulationIndexParameter.id],
        m3: params[b1.modulationIndexParameter.id],
        m4: params[b2.modulationIndexParameter.id],
        hd1: c.harmonicityParameter.depth,
        hd2: a.harmonicityParameter.depth,
        hd3: b1.harmonicityParameter.depth,
        hd4: b2.harmonicityParameter.depth,
        md1: c.modulationIndexParameter.depth,
        md2: a.modulationIndexParameter.depth,
        md3: b1.modulationIndexParameter.depth,
        md4: b2.modulationIndexParameter.depth,
        algo: props.instrument.algorithmParameter.get(true)
    };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setSelectedZObject: x => dispatch(setSelectedZObject(x))
  };
};

const getModList = (instrument) => {
    return instrument.oscillatorNodes.map(
        osc => instrument.adjacencyLists[osc.id].filter(x => ['C', 'B1', 'B2', 'A'].includes(x.effect.name)).length > 0 ? 1 : 0.1);
};

export default connect(mapStateToProps, mapDispatchToProps)(FMShader);
